import { useTranslation } from 'react-i18next';

export default function CompetitorSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            {t('competitors.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            {t('competitors.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12">
          <div className="bg-background-50 rounded-xl p-6 border border-background-200/50">
            <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center mb-4">
              <i className="ri-file-list-3-line text-secondary-600 text-lg"></i>
            </div>
            <h4 className="text-base font-heading font-semibold text-foreground-900 mb-2">
              {t('competitors.comp1Name')}
            </h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              {t('competitors.comp1Desc')}
            </p>
          </div>

          <div className="bg-background-50 rounded-xl p-6 border border-background-200/50">
            <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center mb-4">
              <i className="ri-book-open-line text-secondary-600 text-lg"></i>
            </div>
            <h4 className="text-base font-heading font-semibold text-foreground-900 mb-2">
              {t('competitors.comp2Name')}
            </h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              {t('competitors.comp2Desc')}
            </p>
          </div>

          <div className="bg-background-50 rounded-xl p-6 border border-background-200/50">
            <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center mb-4">
              <i className="ri-reddit-line text-secondary-600 text-lg"></i>
            </div>
            <h4 className="text-base font-heading font-semibold text-foreground-900 mb-2">
              {t('competitors.comp3Name')}
            </h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              {t('competitors.comp3Desc')}
            </p>
          </div>
        </div>

        <div className="bg-accent-500/10 rounded-2xl p-6 md:p-8 border border-accent-300/30">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center">
              <i className="ri-star-fill text-white text-lg"></i>
            </div>
            <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
              {t('competitors.advantageTitle')}
            </h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-3">
            {[
              t('competitors.advantage1'),
              t('competitors.advantage2'),
              t('competitors.advantage3'),
              t('competitors.advantage4'),
              t('competitors.advantage5'),
            ].map((adv) => (
              <div key={adv} className="flex items-center gap-2 bg-background-50/80 rounded-lg px-4 py-3">
                <i className="ri-check-fill text-accent-600 text-sm flex-shrink-0"></i>
                <span className="text-sm text-foreground-700">{adv}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}